import React, { useState, useEffect } from 'react';
import LocalImages from './../../static';
import { dateFormatter } from 'src/shared/utils/src';
import { DATE_FORMATS, MEDICINE_FORM_STATUS } from 'src/shared/config/src';
import { ChildrenStoreData, MedicineFormResponseType, TimelineStateType } from 'src/shared/types/src';
import { getMedicineFormAPI, signDosageAPI } from 'src/shared/services/src';
import { useAppDispatch, useAppSelector } from '../../services/store';
import { fetchTimelineData, getCurrentChild, getTimelineFilters, isTimelineFilterApplied } from 'src/shared/redux-state/src';
import { AxiosError } from 'axios';
import { GlobalErrorActions } from 'src/shared/redux-state/src/lib/globalError/GlobalErrorSlice';
import { uploadFileAsync } from 'src/shared/services/src/lib/fileUpload';
import { TimelineActions } from 'src/shared/redux-state/src/lib/timeline/TimelineSlice';
import { useParams, useNavigate } from 'react-router-dom'
import { BaseCard, CustomButton, CustomCheckbox, CustomImageView, ErrorStatusTag, MedicineFormLoader, SignatureViewModal, SuccessStatusTag, WarningStatusTag } from 'src/app/components';
import ProfileLayout from 'src/app/layouts/ProfileLayout';
import MediaCarouselModal from 'src/app/components/modals/MediaCarouselModal';
import Slider from 'react-slick';
import { AppRoutes } from 'src/app/navigation/routes';
import TextRenderer from 'src/app/components/commonComponents/TextRenderer';

const MedicineFormDetails = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { id } = useParams();

    const currentChild: ChildrenStoreData = useAppSelector(getCurrentChild);

    const [formDetails, setFormDetails] = useState<MedicineFormResponseType>();
    const [loading, setLoading] = useState<boolean>();
    // const [signLoading, setSignLoading] = useState<boolean>();
    // const [submitting, setSubmitting] = useState<boolean>();
    // const [isApiError, setApiError] = useState<boolean>(false);
    // const [apiErrorMsg, setApiErrorMsg] = useState(APP_MESSAGES.generalErrorMessage);
    // const [showSuccessSnack, setShowSuccessSnack] = useState(false);
    // const [successSnackMsg, setSuccessSnackMsg] = useState('');
    const [unsignedDose, setUnsignedDose] = useState<any>([]);
    // const [tempSignIds, setTempSignIds] = useState<any>([]);
    const [doses, setDoses] = useState<any>([]);
    const [formStatus, setFormStatus] = useState<string>('');
    const [tempSignObj, setTempSignObj] = useState<any>();
    // const [signDoseModal, setSignDoseModal] = useState<boolean>(false);
    const [showSignModal, setShowSignModal] = useState<boolean>(false);
    const [showMediaCarouselModal, setShowMediaCarouselModal] = useState<boolean>(false);
    const isDesktop = window.innerWidth > 767;
    const temperatureLength = formDetails?.temperature.length || 0;
    const recordAdministrationLength = doses?.length || 0; 
    const [isPrinting, setIsPrinting] = useState<boolean>(false);

    // const ACTION_SIGN = 'SIGN';
    // const ACTION_SUBMIT = 'SUBMIT';
    const SIGN_TYPE_WITNESS = 'SIGN_TYPE_WITNESS';
    const SIGN_TYPE_PARENT = 'SIGN_TYPE_PARENT';
    const SIGN_TYPE_ADMINISTRATOR = 'SIGN_TYPE_ADMINISTRATOR'

    useEffect(() => {
        fetchMedicineForm();
    }, []);

    useEffect (() => {
        const handleBeforePrint = () => {
            setIsPrinting(true);
        };

        const handleAfterPrint = () => {
            setIsPrinting(false);
        };

        window.addEventListener("beforeprint", handleBeforePrint);
        window.addEventListener("afterprint", handleAfterPrint);

        return () => {
            window.removeEventListener("beforeprint", handleBeforePrint);
            window.removeEventListener("afterprint", handleAfterPrint);
        };
    })

    const fetchMedicineForm = async () => {
        try {
            setLoading(true);
            const response = await getMedicineFormAPI({
                child: currentChild,
                medicineFormID: Number(id),
            }) as MedicineFormResponseType;

            if (response && Object.keys(response).length > 0) {
                setFormDetails(response);
                setFormStatus(response.status);

                if (response?.doses.length > 0) {
                    const unsignedArr = response?.doses.filter((el: any) => !el?.isDoseSigned);
                    setUnsignedDose(unsignedArr);
                    setDoses(response?.doses);
                    // if (response.status === MEDICINE_FORM_STATUS.PENDING_PARENT_REVIEW) {
                    //     const data = unsignedArr.map((el: any) => el?.id)
                    //     setTempSignIds(data)
                    // };
                }
            } else {
                // setApiError(true)
            }

        } catch (error) {
            if (error instanceof AxiosError) {
                const { errors } = error.response?.data;
                if (errors && Object.keys(errors).length > 0) {
                    // setApiError(true);
                    // setApiErrorMsg(JSON.stringify(errors));
                } else {
                    // setApiError(true);
                    // setApiErrorMsg(APP_MESSAGES.generalErrorMessage);
                }
            } else {
                // setApiError(true);
                // setApiErrorMsg(APP_MESSAGES.generalErrorMessage);
            }
        } finally {
            setLoading(false);
        }
    };

    // const uploadSign = async (imgURL: string) => {
    //     const fileObj: any = {
    //         name: JSON.stringify(Date.now()),
    //         uri: imgURL,
    //         type: 'image/png',
    //     }

    //     const formData = new FormData()
    //     formData.append("attachment", fileObj);


    //     const signRes = await uploadFileAsync({
    //         child: currentChild,
    //         formData: formData
    //     });

    //     console.log("uploadedSign", signRes)

    //     if (signRes) {
    //         return signRes
    //     }

    //     return null
    // };

    // const completeMedicineForm = async () => {
    //     try {
    //         setSubmitting(true);
    //         const medicineFormID = Number(id);
    //         const payload = {
    //             action: ACTION_SUBMIT
    //         };

    //         const response = await signDosageAPI({
    //             child: currentChild,
    //             medicineFormID,
    //             params: payload
    //         });

    //         if (response && Object.keys(response).length) {
    //             if (formStatus === MEDICINE_FORM_STATUS.PENDING_PARENT_REVIEW) {
    //                 setSuccessSnackMsg("Medicine form completed")
    //                 setShowSuccessSnack(true);
    //                 setFormStatus(MEDICINE_FORM_STATUS.COMPLETED);
    //                 dispatch(TimelineActions.updateMedicineFormStatusInTimeline({ medicineFormID, status: MEDICINE_FORM_STATUS.COMPLETED }));
    //             };

    //             // scroll to top of the

    //         } else {
    //             setApiError(true);
    //         }
    //     } catch (error) {
    //         console.log("Error completing the form: ", error);
    //         if (error instanceof AxiosError) {
    //             const apiError = error as AxiosError;
    //             if (apiError && apiError.response) {
    //                 const { errors } = error.response?.data;
    //                 setApiError(true);
    //                 setApiErrorMsg(errors.length ? errors.join('') : APP_MESSAGES.generalErrorMessage);
    //             } else {
    //                 setApiError(true);
    //                 setApiErrorMsg(APP_MESSAGES.generalErrorMessage);
    //             }
    //         }
    //     } finally {
    //         setSubmitting(false);
    //     }
    // }

    // const signDosage = async (imgURL: string) => {
    //     try {
    //         setSignLoading(true);
    //         const medicineFormID = Number(id);
    //         const signRes = await uploadSign(imgURL);

    //         if (signRes) {

    //             const payload = {
    //                 action: tempSignIds.length > 0 ? ACTION_SIGN : ACTION_SUBMIT,
    //                 dosageIds: tempSignIds || [],
    //                 fileName: signRes?.fileName || ''
    //             };

    //             const response = await signDosageAPI({
    //                 child: currentChild,
    //                 medicineFormID,
    //                 params: payload
    //             });

    //             if (response) {
    //                 if (response.length > 0) {
    //                     const unsignedArr: any = [];
    //                     const dosesArr = doses.map((el: any) => {
    //                         const doseItem = response.find((item: any) => item?.id == el?.id);
    //                         if (doseItem) {
    //                             return doseItem
    //                         } else {
    //                             if (!el?.isDoseSigned) {
    //                                 unsignedArr.push(el)
    //                             };
    //                             return el
    //                         }
    //                     });

    //                     setDoses(dosesArr);
    //                     setUnsignedDose(unsignedArr)
    //                 };

    //                 if (formStatus === MEDICINE_FORM_STATUS.IN_PROGRESS) {
    //                     setSuccessSnackMsg("Dose(s) signed successfully")
    //                     setShowSuccessSnack(true)
    //                 };

    //                 if (formStatus === MEDICINE_FORM_STATUS.PENDING_PARENT_REVIEW) {
    //                     setSuccessSnackMsg("Medicine form completed")
    //                     setShowSuccessSnack(true);
    //                     setFormStatus(MEDICINE_FORM_STATUS.COMPLETED);
    //                     dispatch(TimelineActions.updateMedicineFormStatusInTimeline({ medicineFormID, status: MEDICINE_FORM_STATUS.COMPLETED }));
    //                 };

    //                 // scroll to top of the 

    //                 // fetchTimelineList(1);
    //             }
    //         } else {
    //             setApiError(true);
    //         }
    //     } catch (error) {
    //         console.log("Error Signing Dosage", error)
    //         if (error instanceof AxiosError) {
    //             const apiError = error as AxiosError;
    //             if (apiError && apiError.response) {
    //                 const { errors } = error.response?.data;
    //                 setApiError(true);
    //                 setApiErrorMsg(errors);
    //             } else {
    //                 setApiError(true);
    //                 setApiErrorMsg(APP_MESSAGES.generalErrorMessage);
    //             }
    //         }
    //     } finally {
    //         setSignLoading(false);
    //         setTempSignIds([]);
    //     }
    // };

    const toggleMediaCarouselModal = () => {
        setShowMediaCarouselModal(!showMediaCarouselModal);
    }

    const renderShowCarousel = () => {
        toggleMediaCarouselModal()
        console.log('here carousel', formDetails?.labelEvidenceAttachments)
    };

    const renderAttachments = (item: any) => {
        return (
            <div className="pd-x-4 mg-t-8 accident-avatar-img-wrap">
                <CustomImageView
                    url={item?.media?.url}
                    onPressImage={renderShowCarousel}
                    resizeMode='contain'
                    customImageStyles="accident-avatar-img"
                />
            </div>
        )
    };

    const renderTemperatures = (item: any, index: number) => {
        return (
            <div key={index} className='pd-x-8 h-100'>
                <div className='pd-20 border border-white-500 rounded-3 h-100'>
                    <div className='fs-5'>{item?.recordedTemperature} °C</div>
                    <p className='mg-b-0 fs-12 text-black opacity-50 mg-t-5'>{dateFormatter(item?.timestamp, DATE_FORMATS.SHORT_DATE)}</p>
                    <p className='mg-b-0 fs-12 text-black opacity-50'>{dateFormatter(item?.timestamp, DATE_FORMATS.TIME_AMPM)}</p>
                    <p className='mg-b-0 fs-14 text-black mg-t-7'>{item?.bodyPart}</p>
                </div>
            </div>
        )
    };
    const renderTemperaturesSlider = () => (
        <Slider {...temperatureSlider}>
            {formDetails?.temperature.map((item: any, index: number) => {
                return renderTemperatures(item, index)
            })}
        </Slider>
    );
      
    const renderTemperaturesGrid = () => (
        <div className='d-flex'>
            {formDetails?.temperature.map((item: any, index: number) => {
                return (
                    <div style={{ width: isDesktop ? 'calc(100% / 5)' : '50%' }} key={index}>
                        {renderTemperatures(item, index)}
                    </div>
                )
            })}
        </div>
    );

    const renderRecordAdministrationSlider = () => (
        <Slider {...recordOfAdministrationSlider}>
            {doses.map((item: any, index: number) => {
                return renderRecordOfAdministration(item, index)
            })}
        </Slider>
    );
      
    const renderRecordAdministrationGrid = () => (
        <div className='d-flex mx-n-8'>
            {doses.map((item: any, index: number) => {
                return (
                    <div className={`${isDesktop ? 'w-50' : 'w-100'} pd-x-8`} key={index}>
                        {renderRecordOfAdministration(item, index)}
                    </div>
                )
            })}
        </div>
    );

    // const handleClickDose = (id: number) => {
    //     if (tempSignIds.includes(id)) {
    //         setTempSignIds((idArr: any) => idArr.filter((el: any) => el !== id))
    //     } else {
    //         setTempSignIds((idsArr: any) => [...idsArr, id])
    //     }
    // }

    // const renderSignList = (item: any) => {
    //     return (
    //         <div onClick={() => {
    //                 if (formStatus === MEDICINE_FORM_STATUS.PENDING_PARENT_REVIEW) return
    //                 handleClickDose(item?.id)
    //             }}
    //         >
    //             <div >
    //                 <p>{item?.dose}</p>
    //                 <p>{dateFormatter(item?.timestamp, DATE_FORMATS.LONG_DATE_WITH_TIME)}</p>
    //             </div>
    //             <div>
    //                 <CustomCheckbox isChecked={tempSignIds.includes(item?.id)} onChange={(e) => handleClickDose(item?.id)}/>
    //             </div>
    //         </div>
    //     )
    // };

    // const toggleSignDoseModal = () => {
    //     setSignDoseModal(!signDoseModal)
    // }

    // const renderSignDoseModal = () => {
    //     return (
    //         <Modal
    //              isOpen={signDoseModal}
    //              toggle={toggleSignDoseModal}
    //              backdrop={"static"}
    //              keyboard={false}
    //              centered={true}
    //                className = {`custom-modal-md modal-dialog-bottom modal-dialog-bottom-style`}
    //                modalClassName = {`modal-slide-down`}
    //            >
    //         <ModalHeader>Dose(s) Published by Nursery</ModalHeader>
    //         <ModalBody>
    //             {
    //                 unsignedDose && unsignedDose.map((item: any) => {
    //                     return renderSignList(item)
    //                 })
    //             }
    //         </ModalBody>
    //         <ModalFooter className='d-block'>
    //             <div className='d-flex w-100 mx-n-8'>
    //                 <div className='w-50 pd-x-8'>
    //                     <CustomButton
    //                         onClick={() => {
    //                             if (tempSignIds.length == 0) {
    //                                 return dispatch(GlobalErrorActions.setError({ isError: true, message: 'Please select doses to sign' }));
    //                             }
    //                             toggleSignDoseModal()
    //                         }}
    //                         isLoading={loading}
    //                         text='Sign Dose(s) Now '
    //                         color={'primary'}
    //                     />
    //                 </div>
    //             </div>
    //         </ModalFooter>
    //     </Modal>
    //     )
    // }

    const toggleShowSignModal = () => {
        setShowSignModal(!showSignModal)
    }

    const renderShowSignModal = () => {
        const getHeader = () => {
            if (tempSignObj?.type === SIGN_TYPE_ADMINISTRATOR) return 'Administrator';
            if (tempSignObj?.type === SIGN_TYPE_PARENT) return 'Parent';
            if (tempSignObj?.type === SIGN_TYPE_WITNESS) return 'Witness';
        };

        return (
            <SignatureViewModal
                isModal={showSignModal}
                toggleModal={toggleShowSignModal}
                signObj={tempSignObj}
                type={getHeader()}
            />
        )
    }

    const renderRecordOfAdministration = (item: any, index: any) => {
        return (
            <div className='pd-x-8'>
                <div className='pd-20 border border-white-500 rounded-3 h-100' key={index}>
                    <div className='d-flex'>
                        <div className='form-group flex-1 mg-r-10'>
                            <div className='form-label text-gray-300 mb-1 fs-12'>Dose</div>
                            <div className='form-control read-only-control d-flex align-items-center'>{item.dose}</div>
                        </div>

                        {item?.isDoseSigned && (
                            <div className='cursor-pointer print-element-hide'
                                onClick={() => {
                                    const data = {
                                        ...item?.parentDetails,
                                        type: SIGN_TYPE_PARENT
                                    }
                                    setTempSignObj(data);
                                    toggleShowSignModal();
                                }}
                            >
                                <SuccessStatusTag statusString='Signed' />
                            </div>
                        )}

                        {!item?.isDoseSigned && (
                            <div>
                                <ErrorStatusTag statusString='Not Signed' />
                            </div>
                        )}
                    </div>
                    {item?.isDoseSigned && (
                        <div className='form-group mg-t-15 visible-in-print-view'>
                            <div className='form-label text-gray-300 mb-1 fs-12'>Signature</div>
                            <div className='cursor-pointer'>
                                <img src={item?.parentDetails?.signature?.url} alt="eye icon" style={{ width: '50%', height: '50px' }}  className='visible-in-print-view' />
                            </div>
                        </div>
                    )}
                    <div className='form-group mg-t-15'>
                        <div className='form-label text-gray-300 mb-1 fs-12'>Date & time</div>
                        <div className='form-control read-only-control d-flex align-items-center'>{dateFormatter(item?.timestamp, DATE_FORMATS.LONG_DATE_WITH_TIME)}</div>
                    </div>
                    <div className='row gutters-8'>
                        <div className={`${item?.administratorDetails?.signature?.url ? 'col-md-9 col-6' : 'col-12'} form-group mg-t-15`}>
                            <div className='form-label text-gray-300 mb-1 fs-12'>Administrator</div>
                            <div className='form-control read-only-control d-flex align-items-center'>{item?.administratorDetails?.name}</div>
                        </div>
                        {item?.administratorDetails?.signature?.url && (
                            <div className='col-md-3 col-6 form-group mg-t-15 d-flex flex-column align-items-end'>
                                <div>
                                    <div className='form-label text-gray-300 mb-1 fs-12'>Signature</div>
                                    <div className='cursor-pointer' onClick={() => {
                                        const data = {
                                            ...item?.administratorDetails,
                                            type: SIGN_TYPE_ADMINISTRATOR,
                                        }
                                        setTempSignObj(data);
                                        toggleShowSignModal();
                                    }}
                                    >
                                        <img src={LocalImages.eyeIcon} alt="eye icon" style={{ width: '20px' }} className='cursor-pointer print-element-hide' />
                                        <img src={item?.administratorDetails?.signature?.url} alt="eye icon" style={{ width: '50%', height: '50px' }}  className='visible-in-print-view' />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className='row gutters-8'>
                        <div className={`${item?.witnessDetails?.signature?.url ? 'col-md-9 col-6' : 'col-12'} form-group mg-t-15`}>
                            <div className='form-label text-gray-300 mb-1 fs-12'>Witness</div>
                            <div className='form-control read-only-control d-flex align-items-center'>{item?.witnessDetails?.name}</div>
                        </div>
                        {item?.witnessDetails?.signature?.url && (
                            <div className='col-md-3 col-6 form-group mg-t-15 d-flex flex-column align-items-end'>
                                <div>
                                    <div className='form-label text-gray-300 mb-1 fs-12'>Signature</div>
                                    <div className="cursor-pointer" onClick={() => {
                                        const data = {
                                            ...item?.witnessDetails,
                                            type: SIGN_TYPE_WITNESS
                                        }
                                        setTempSignObj(data);
                                        toggleShowSignModal();
                                    }}
                                    >
                                        <img src={LocalImages.eyeIcon} alt="eye icon" style={{ width: '20px' }} className='cursor-pointer print-element-hide' />
                                        <img src={item?.witnessDetails?.signature?.url} alt="eye icon" style={{ width: '50%', height: '50px' }} className='visible-in-print-view' />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        )
    };

    if (loading) {
        return <MedicineFormLoader />
    }

    const getYesNo = (label: boolean | null | undefined) => {
        if (label === true) {
            return 'Yes'
        };

        if (label === false) {
            return 'No'
        };

        return ''
    }

    const temperatureSlider = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 5,
        swipeToSlide: true,
        arrows: false,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2.3,
                }
            },
        ]
    };

    const recordOfAdministrationSlider = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1.5,
        swipeToSlide: true,
        arrows: false,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1.3,
                }
            },
        ]
    };

    const navigateToDownloadAppScreen = () => {
        navigate(AppRoutes.MOBILE_APP)
    }

    return (
        <ProfileLayout title={"Medicine Form"} fixedFooter={formStatus == MEDICINE_FORM_STATUS.PENDING_PARENT_REVIEW || unsignedDose.length > 0 && (formStatus == MEDICINE_FORM_STATUS.IN_PROGRESS) ?  true : false} isPrintPage={true} handlePrint={() => window.print()}>
            {/* {signLoading ? <div>Full screen Loader...</div> : null} */}

            <>
                {formStatus && (
                    <div className="d-flex align-items-center justify-content-center">
                        {formStatus === MEDICINE_FORM_STATUS.COMPLETED && (
                            <SuccessStatusTag statusString={formStatus} />
                        )}
                        {formStatus !== MEDICINE_FORM_STATUS.COMPLETED && (
                            <WarningStatusTag statusString={formStatus} />
                        )}
                    </div>
                )}
                {formDetails?.timestamp ? <div className="text-center fs-14 text-black mg-t-15">
                    {dateFormatter(formDetails.timestamp, DATE_FORMATS.LONG_DATE_WITH_TIME)}
                </div> : null}
                <div className="mx-n-20 pd-x-20">
                    <div className='form-group mg-t-15'>
                        <div className='form-label text-gray-300 mb-1 fs-12'>Name of medicine</div>
                        <div className='form-control read-only-control d-flex align-items-center'>{formDetails?.medicineDetails?.name || ''}</div>
                    </div>
                    <div className='form-group mg-t-15'>
                        <div className='form-label text-gray-300 mb-1 fs-12'>Medication type</div>
                        <div className='form-control read-only-control d-flex align-items-center'>{formDetails?.medicineDetails?.type || ''}</div>
                    </div>
                    <div className='form-group mg-t-15'>
                        <div className='form-label text-gray-300 mb-1 fs-12'>Expiry date</div>
                        {formDetails?.medicineDetails?.expiryDate ? <div className='form-control read-only-control d-flex align-items-center'>{dateFormatter(formDetails?.medicineDetails?.expiryDate, DATE_FORMATS.SHORT_DATE) || ''}</div> : null}
                    </div>
                </div>
                <div className="mx-n-20 pd-x-20 mg-t-15 border-top border-gray border-t-w-6">
                    <div className='form-group mg-t-15'>
                        <div className='form-label text-gray-300 mb-1 fs-12'>Does the medication contain aspirin?</div>
                        <div className='form-control read-only-control d-flex align-items-center'>{formDetails?.medicineDetails?.containsAspirin ? 'Yes' : 'No'}</div>
                    </div>

                    <div className='form-group mg-t-15'>
                        <div className='form-label text-gray-300 mb-1 fs-12'>Is the pharmacy label clear and state the correct information</div>
                        <div className='form-control read-only-control d-flex align-items-center'>{getYesNo(formDetails?.medicineDetails?.isPharmacyLabelClear)}</div>
                    </div>

                    <div className='form-group mg-t-8'>
                        <div className="d-flex flex-wrap mx-n-4">
                            {formDetails?.labelEvidenceAttachments && formDetails?.labelEvidenceAttachments.map((item) => {
                                return renderAttachments(item)
                            })}
                        </div>
                    </div>

                    <div className='form-group mg-t-15'>
                        <div className='form-label text-gray-300 mb-1 fs-12'>Where is the medication required to be stored?</div>
                        <div className='form-control read-only-control d-flex align-items-center'>{formDetails?.medicineDetails?.storageLocation || ''}</div>
                    </div>

                    <div className='form-group mg-t-15'>
                        <div className='form-label text-gray-300 mb-1 fs-12'>Does the medication have an instruction leaflet and in original packaging?</div>
                        <div className='form-control read-only-control d-flex align-items-center'>{getYesNo(formDetails?.medicineDetails?.hasInstructionLeaflet)}</div>
                    </div>

                </div>
                <div className="mx-n-20 pd-x-20 mg-t-15 border-top border-gray border-t-w-6">
                    <div className='form-group mg-t-15'>
                        <div className='form-label text-gray-300 mb-1 fs-12'>Prescribed dosage</div>
                        <div className='form-control read-only-control d-flex align-items-center'>{formDetails?.medicineDetails?.prescribedDosage || ''}</div>
                    </div>
                    <div className='form-group mg-t-15'>
                        <div className='form-label text-gray-300 mb-1 fs-12'>How often should the medicine be administered?</div>
                        <div className='form-control read-only-control d-flex align-items-center'>{formDetails?.medicineDetails?.administrationFrequency || ''}</div>
                    </div>
                    <div className='form-group mg-t-15'>
                        <div className='form-label text-gray-300 mb-1 fs-12'>Last administered by the parent (If applicable) </div>
                        {formDetails?.medicineDetails?.lastAdministeredTimestamp ? <div className='form-control read-only-control d-flex align-items-center'>{dateFormatter(formDetails?.medicineDetails?.lastAdministeredTimestamp, DATE_FORMATS.LONG_DATE_WITH_TIME) || ''}</div> : null}
                    </div>

                </div>

                <div className="mx-n-20 pd-x-20 mg-t-15 border-top border-gray border-t-w-6">
                    <div className='form-group mg-t-15'>
                        <div className='form-label text-gray-300 mb-1 fs-12'>Special Instructions</div>
                        <div className='form-control read-only-control d-flex align-items-center'>{formDetails?.instructions || ''}</div>
                    </div>
                    <div className='form-group mg-t-15'>
                        <div className='form-label text-gray-300 mb-1 fs-12'>Notes</div>
                        <div className='form-control read-only-control'><TextRenderer text={formDetails?.notes || ''} /></div>
                    </div>
                    <div className='form-group mg-t-15'>
                        <div className='form-label text-gray-300 mb-1 fs-12'>Condition</div>
                        <div className='form-control read-only-control d-flex align-items-center'>{formDetails?.condition || ''}</div>
                    </div>
                </div>

                <div className="mx-n-20 pd-x-20 mg-t-15 border-top border-gray border-t-w-6">

                    {formDetails?.temperature && formDetails?.temperature.length ?
                        <div className='form-group mg-t-15'>
                            <div className='form-label text-gray-300 mb-1 fs-12'>Temperature</div>
                            
                            <div className='slider-container mg-t-10 mx-n-8 visible-in-print-view'>{renderTemperaturesGrid()}</div> 
                            <div className='print-element-hide slider-container mg-t-10 mx-n-8'>
                                {isDesktop ? (
                                    temperatureLength > 5 ? (
                                        renderTemperaturesSlider()
                                    ) : (
                                        renderTemperaturesGrid()
                                    )
                                    ) : (
                                    temperatureLength > 2 ? (
                                        renderTemperaturesSlider()
                                    ) : (
                                        renderTemperaturesGrid()
                                    )
                                )}
                            </div>
                        </div>
                        : null
                    }

                    {formStatus !== MEDICINE_FORM_STATUS.PENDING_NURSERY_REVIEW && formStatus !== MEDICINE_FORM_STATUS.REJECTED && (
                        <>
                            <div className='form-group mg-t-15'>
                                <div className='form-label text-gray-300 mb-1 fs-12'>Name of the staff member who accepted the medicine</div>
                                <div className='form-control read-only-control d-flex align-items-center'>{formDetails?.staffMedicineAccepted || ''}</div>
                            </div>
                            <div className='form-group mg-t-15'>
                                <div className='form-label text-gray-300 mb-1 fs-12'>Medication box/bottle checked by nursery staff on handover:</div>
                                <div className='form-control read-only-control d-flex align-items-center'>{getYesNo(formDetails?.medicationBox)}</div>
                            </div>
                            <div className='form-group mg-t-15'>
                                <div className='form-label text-gray-300 mb-1 fs-12'>Medication is labelled with the child’s name, DOB, dose and date:</div>
                                <div className='form-control read-only-control d-flex align-items-center'>{getYesNo(formDetails?.medicationLabel)}</div>
                            </div>
                        </>
                    )}

                    {doses && doses.length ?
                        <div className='form-group mg-t-15'>
                            <div className='form-label text-gray-300 mb-1 fs-12'>Record of administration</div>

                            <div className="slider-container mg-t-10 mx-n-8 print-record-administration visible-in-print-view">{renderRecordAdministrationGrid()}</div>
                            <div className="slider-container mg-t-10 mx-n-8 print-element-hide">
                                {recordAdministrationLength > 1 ? (
                                        renderRecordAdministrationSlider()
                                    ) : (
                                        renderRecordAdministrationGrid()
                                    )
                                }
                            </div>
                            {/* {doses.map((item: any, index: number) => {
                                return renderRecordOfAdministration(item, index)
                            })} */}
                        </div>
                        : null
                    }

                </div>

                {
                    (formDetails?.parentContactedDetails?.isParentContacted) ?
                        <>
                            <div className='form-group mg-t-15'>
                                <div className='form-label text-gray-300 mb-1 fs-12'>Parent Contacted</div>
                                <div className='form-control read-only-control d-flex align-items-center'>Yes</div>
                            </div>
                            <div className='form-group mg-t-15'>
                                <div className='form-label text-gray-300 mb-1 fs-12'>Staff Name</div>
                                <div className='form-control read-only-control d-flex align-items-center'>{formDetails?.parentContactedDetails?.staffName || ''}</div>
                            </div>
                            <div className='form-group mg-t-15'>
                                <div className='form-label text-gray-300 mb-1 fs-12'>Date & Time</div>
                                <div className='form-control read-only-control d-flex align-items-center'>
                                    {formDetails?.parentContactedDetails?.timestamp ? dateFormatter(formDetails?.parentContactedDetails?.timestamp, DATE_FORMATS.LONG_DATE_WITH_TIME) : ''}
                                </div>
                            </div>
                            <div className='form-group mg-t-15'>
                                <div className='form-label text-gray-300 mb-1 fs-12'>Notes</div>
                                <div className='form-control read-only-control'><TextRenderer text={formDetails?.parentContactedDetails?.notes || ''} /></div>
                            </div>
                        </>
                        : null
                }
            </>

            {/* {renderSignDoseModal()} */}

            {renderShowSignModal()}
            
            {formStatus == MEDICINE_FORM_STATUS.PENDING_PARENT_REVIEW ? 
                <div className="section-fixed pd-b-10 pd-t-10 pd-x-20 print-element-hide"><CustomButton
                    text={'Submit & Complete'}
                    onClick={navigateToDownloadAppScreen}
                    color={"primary"}
                /></div> : null
            }

            {unsignedDose.length > 0 && (formStatus == MEDICINE_FORM_STATUS.IN_PROGRESS) && (
                <div className="section-fixed pd-b-10 pd-t-10 pd-x-20 print-element-hide"><CustomButton
                    text={'Sign Dose(s)'}
                    onClick={navigateToDownloadAppScreen}
                    color={"primary"}
                /></div>
            )}
            {/* {formStatus === MEDICINE_FORM_STATUS.IN_PROGRESS ? 
                <CustomButton
                    text={'Sign Dose(s)'}
                    onClick={navigateToDownloadAppScreen}
                    color={"primary"}
                /> : null
            } */}

            <MediaCarouselModal
                showMediaCarouselModal={showMediaCarouselModal}
                toggleMediaCarouselModal={toggleMediaCarouselModal}
                media={formDetails?.labelEvidenceAttachments || []}
            />
        </ProfileLayout>
    )
}

export default MedicineFormDetails